import { Box, Button, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ReactComponent as UploadSuccessful } from '../../../assets/Upload_success.svg'
import FsContainer from '../common/Container'
import { formatDate } from '../../../shared/utils'
import { useAppSelector } from '../../../store/hooks'

const FsDataPreparation = () => {
  const { t, i18n } = useTranslation()
  const { latestEtlStatus } = useAppSelector((state) => state.currentEtl)
  const navigate = useNavigate()
  const defaultLocale = i18n.language === 'en' ? 'en' : 'de'
  const correspondance = latestEtlStatus ? new Date(latestEtlStatus.dateEffective) : null
  const formattedCorrespondanceDate = correspondance
    ? formatDate(correspondance, defaultLocale, 'dd.mm.yyyy')
    : null

  return (
    <FsContainer>
      <Typography mb={4}>
        {t('data.received', {
          date: formattedCorrespondanceDate,
          interpolation: { escapeValue: false },
        })}
      </Typography>
      <Box pl={20}>
        <UploadSuccessful />
      </Box>
      <Typography mt={4}>{t('data.received.info')}</Typography>
      <Button variant="contained" onClick={() => navigate('/fs/help')} sx={{ mt: 2, ml: 16 }}>
        {t('go.to.help.center')}
      </Button>
    </FsContainer>
  )
}

export default FsDataPreparation
